import { Component, OnInit } from '@angular/core';
import { WidgetMapService } from 'app/widgets/widget-map.service';
import { WidgetService } from 'app/widgets/widget.service';
import { WidgetDetailInstanceService } from '../widget-detail-instance.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'cw-widget-detail-preview',
  templateUrl: './widget-detail-preview.component.html',
  styleUrls: ['./widget-detail-preview.component.scss']
})
export class WidgetDetailPreviewComponent implements OnInit {

  constructor(private instance: WidgetDetailInstanceService,
              private mapService: WidgetMapService,
              private widgetService: WidgetService,
              private sanitizer: DomSanitizer) {
    this.instance.$widget.subscribe(widget => {

    });

  }

  ngOnInit() {
  }

  get widget() {
    return this.instance.widget;
  }

  get canBePreviewed() {
    return this.widget.previewUrl;
  }

  get widgetPreviewUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.widget.previewUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/widget-detail-preview/widget-detail-preview.component.ts